<template> 
  <div class='px-3 py-3 mb-5 col-24 col-md-11'>
    <div class='col d-column'>
      <h1 class="title pt-2 mb-0" v-text="$ml.get('myPlan')"></h1>
      <h1 class="title"><span  class="pb-2" v-text="$ml.get('manageYourPlanInformation')">Gerencie as informações do seu plano.</span></h1> 
      <div class='col d-column'>
       
        <div class='card card-green'>
          <div class='card-body'>
            <div class='row'>
              <div class='col-3 p-2'>
                <img src='../../assets/images/plan-upgrade.png' class='img-fluid' />
              </div>
              <div v-if="planSelected" class='col-21 p-4'>
                <h2 class="size-1_4"><font v-text="$ml.get('yourCurrentPlanIsThe')">Seu plano atual é </font>: <font v-text="$ml.get('plan_'+planSelected)"></font></h2>
                <p class='m-0 mb-1' v-text="$ml.get('takeTheOpportunityToAcquireMoreComplete')">Aproveite a oportunidade para adquirir planos mais completos para sua empresa</p>
                <span class='text-muted' v-text="$ml.get('toChangeYourPlanContactSupport')">Para alterar seu plano, entre em contato com o suporte.

                </span>
              </div>
            </div>
          </div>
        </div>

        <div class='row card-plans d-flex justify-content-between'>

          <div :class='"card mt-4 baseBlock " + (planSelected == "trial" ? "selected": "")'> 
            <div class='card-header active' v-text="$ml.get('trial')">
              Trial
            </div>
            <div class='card-body d-flex flex-column' v-html="planTrial"> 
              <!-- <p class='valor'>Grátis</p> --> 
              <!-- <div class=" align-self-center mt-auto">
                <a class='btn btn-disabled btn-full'>Plano Atual</a>
              </div> -->
            </div> 
          </div>

          <div :class='"card mt-4 baseBlock " + (planSelected == "bronze" ? "selected": "")'> 
            <div class='card-header' v-text="$ml.get('bronze')">
              Bronze
            </div>
            <div class='card-body d-flex flex-column' v-html="planBronze">  
              <!-- <div class=" align-self-center mt-auto">
                <a class='btn btn-success btn-full'>Upgrade de Plano</a> 
              </div> -->
            </div> 
          </div>

          <div :class='"card mt-4 baseBlock " + (planSelected == "silver" ? "selected": "")'> 
            <div class='card-header' v-text="$ml.get('silver')">
              Prata
            </div>
            <div class='card-body d-flex flex-column' v-html="planSilver">   
              <!-- <p class='not'>Serviço Gerenciado pela BugHunt</p> --> 
              <!-- <div class=" align-self-center mt-auto">
                <a class='btn btn-success btn-full'>Upgrade de Plano</a> 
              </div>  -->
            </div> 
          </div>

          
          <div :class='"card mt-4 baseBlock " + (planSelected == "gold" ? "selected": "")'>  
            <div class='card-header' v-text="$ml.get('gold')">
              Ouro
            </div>
            <div class='card-body d-flex flex-column' v-html="planGold"> 
              <!-- <p>Serviço Gerenciado pela BugHunt</p> --> 
              <!-- <div class=" align-self-center mt-auto">
                <a class='btn btn-success btn-full'>Upgrade de Plano</a> 
              </div>  -->
            </div> 
          </div>

        </div>


      </div>

    </div> 
  </div>  
</template>

<script>
import PlanService from "../../services/plan.service"; 
 
export default { 
  data() {
    return {
      value: null,
      title: "Plan", 
      planSelected: "", 
      planTrial: null,
      planBronze: null,
      planSilver: null,
      planGold: null,
 
    };
  },
  mounted() {
    this.loadData(); 
    this.planSelected = this.$store.getters['getUser'].plan?.name;
  },

  methods: {
    async loadData() {
      this.loading = true;
      var self = this;
      PlanService.getPlans().then(
        (response) => { 
 
          response.data.forEach(element => {

            if(element.name == "trial"){
              this.planTrial = '';

              // Escopo
              if(element.amount_of_company_members == 0){
                this.planTrial +=
                 `<p class='not'>${self.$ml.get('userByCompany')}</p>`;
              }else{
                this.planTrial +=
                 `<p>${element.amount_of_company_members } ${element.amount_of_company_members > 1 ? self.$ml.get('usersByCompany') : self.$ml.get('userByCompany')}</p>`;
              }
 
              if(element.amount_of_hackers){
                this.planTrial += `<p>${self.$ml.get('upTo')} ${element.amount_of_hackers } Hackers</p>`
              }else{
                this.planTrial += `<p class='not'>${self.$ml.get('hackerControl')}</p>`
              }
  
              // Programas Privados
              if(element.amount_of_private_programs == 0){
                this.planTrial +=
                 `<p class='not'>${self.$ml.get('ccpProgPriv')}</p>`;
              }else{
                this.planTrial +=
                 `<p>${element.amount_of_private_programs } ${element.amount_of_private_programs > 1 ? 'Programas Privados' : self.$ml.get('ccpProgPriv')}</p>`;
              }

              // Programas Públicos
              if(element.amount_of_public_programs == 0){
                this.planTrial +=
                 `<p class='not'>${self.$ml.get('ccpProgPubli')}</p>`;
              }else{
                this.planTrial +=
                 `<p>${element.amount_of_public_programs } ${element.amount_of_public_programs > 1 ? 'Programas Públicos' : self.$ml.get('ccpProgPubli')}</p>`;
              }

              // Programas Públicos
              if(element.amount_of_scopes == 0){
                this.planTrial +=
                 `<p class='not'>${self.$ml.get('scopePerProgram')}</p>`;
              }else{
                this.planTrial +=
                 `<p>${element.amount_of_scopes } ${element.amount_of_scopes > 1 ? self.$ml.get('scopesPerProgram') : self.$ml.get('scopePerProgram')}</p>`;
              }
 
              this.planTrial += `
                <p class="${element.export_reports_to_csv ? '' : 'not'}">${self.$ml.get('exportInCsv')}</p>
                <p class="${element.integration_types.length ? '' : 'not'}">${self.$ml.get('integrations')}<br>(Slack, Teams)</p> 
              ` 
            }

            if(element.name == "bronze"){
              this.planBronze = '';
 
              // Escopo
              if(element.amount_of_company_members == 0){
                this.planBronze +=
                 `<p class='not'>${self.$ml.get('userByCompany')}</p>`;
              }else{
                this.planBronze +=
                 `<p>${element.amount_of_company_members} ${element.amount_of_company_members > 1 ? self.$ml.get('usersByCompany') : self.$ml.get('userByCompany')}</p>`;
              }

              if(element.amount_of_hackers){
                this.planBronze += `<p>${self.$ml.get('upTo')} ${element.amount_of_hackers } Hackers</p>`
              }else{
                this.planBronze += `<p class='not'>${self.$ml.get('hackerControl')}</p>`
              }

              // Programas Privados
              if(element.amount_of_private_programs == 0){
                this.planBronze +=
                 `<p class='not'>${self.$ml.get('ccpProgPriv')}</p>`;
              }else{
                this.planBronze +=
                 `<p>${element.amount_of_private_programs } ${element.amount_of_private_programs > 1 ? 'Programas Privados' : self.$ml.get('ccpProgPriv')}</p>`;
              }

              // Programas Públicos
              if(element.amount_of_public_programs == 0){
                this.planBronze +=
                 `<p class='not'>${self.$ml.get('ccpProgPubli')}</p>`;
              }else{
                this.planBronze +=
                 `<p>${element.amount_of_public_programs } ${element.amount_of_public_programs > 1 ? 'Programas Públicos' : self.$ml.get('ccpProgPubli')}</p>`;
              }

              // Programas Públicos
              if(element.amount_of_scopes == 0){
                this.planBronze +=
                 `<p class='not'>${self.$ml.get('scopePerProgram')}</p>`;
              }else{
                this.planBronze +=
                 `<p>${element.amount_of_scopes } ${element.amount_of_scopes > 1 ? self.$ml.get('scopesPerProgram') : self.$ml.get('scopePerProgram')}</p>`;
              }
 
              this.planBronze += `
                <p class="${element.export_reports_to_csv ? '' : 'not'}">${self.$ml.get('exportInCsv')}</p>
                <p class="${element.integration_types.length ? '' : 'not'}">${self.$ml.get('integrations')}<br>(Slack, Teams)</p> 
              ` 
            }

            if(element.name == "silver"){
              this.planSilver = '';
 
              // Escopo
              if(element.amount_of_company_members == 0){
                this.planBronze +=
                 `<p class='not'>${self.$ml.get('userByCompany')}</p>`;
              }else{
                this.planSilver +=
                 `<p>${element.amount_of_company_members} ${element.amount_of_company_members> 1 ? self.$ml.get('usersByCompany') : self.$ml.get('userByCompany')}</p>`;
              }

              if(element.amount_of_hackers){
                this.planSilver += `<p>${self.$ml.get('upTo')} ${element.amount_of_hackers } Hackers</p>`
              }else{
                this.planSilver += `<p class='not'>${self.$ml.get('hackerControl')}</p>`
              }

              // Programas Privados
              if(element.amount_of_private_programs == 0){
                this.planSilver +=
                 `<p class='not'>${self.$ml.get('ccpProgPriv')}</p>`;
              }else{
                this.planSilver +=
                 `<p>${element.amount_of_private_programs } ${element.amount_of_private_programs > 1 ? 'Programas Privados' : self.$ml.get('ccpProgPriv')}</p>`;
              }

              // Programas Públicos
              if(element.amount_of_public_programs == 0){
                this.planSilver +=
                 `<p class='not'>${self.$ml.get('ccpProgPubli')}</p>`;
              }else{
                this.planSilver +=
                 `<p>${element.amount_of_public_programs } ${element.amount_of_public_programs > 1 ? 'Programas Públicos' : self.$ml.get('ccpProgPubli')}</p>`;
              }

              // Programas Públicos
              if(element.amount_of_scopes == 0){
                this.planSilver +=
                 `<p class='not'>${self.$ml.get('scopePerProgram')}</p>`;
              }else{
                this.planSilver +=
                 `<p>${element.amount_of_scopes } ${element.amount_of_scopes > 1 ? self.$ml.get('scopesPerProgram') : self.$ml.get('scopePerProgram')}</p>`;
              }
 
              this.planSilver += `
                <p class="${element.export_reports_to_csv ? '' : 'not'}">${self.$ml.get('exportInCsv')}</p>
                <p class="${element.integration_types.length ? '' : 'not'}">${self.$ml.get('integrations')}<br>(Slack, Teams)</p> 
              ` 
            }

            if(element.name == "gold"){
              this.planGold = '';
 
              // Escopo
              if(element.amount_of_company_members == 0){
                this.planBronze +=
                 `<p class='not'>${self.$ml.get('userByCompany')}</p>`;
              }else{
                this.planGold +=
                 `<p>${element.amount_of_company_members} ${element.amount_of_company_members > 1 ? self.$ml.get('usersByCompany') : self.$ml.get('userByCompany')}</p>`;
              }

              if(element.amount_of_hackers){
                this.planGold += `<p>${self.$ml.get('upTo')} ${element.amount_of_hackers } Hackers</p>`
              }else{
                this.planGold += `<p class='not'>Controle de Hackers</p>`
              }

              // Programas Privados
              if(element.amount_of_private_programs == 0){
                this.planGold +=
                 `<p class='not'>${self.$ml.get('ccpProgPriv')}</p>`;
              }else{
                this.planGold +=
                 `<p>${element.amount_of_private_programs } ${element.amount_of_private_programs > 1 ? self.$ml.get('msgProgramPr') : self.$ml.get('ccpProgPriv')}</p>`;
              }

              // Programas Públicos
              if(element.amount_of_public_programs == 0){
                this.planGold +=
                 `<p class='not'>${self.$ml.get('ccpProgPubli')}</p>`;
              }else{
                this.planGold +=
                 `<p>${element.amount_of_public_programs } ${element.amount_of_public_programs > 1 ? 'Programas Públicos' : self.$ml.get('ccpProgPubli')}</p>`;
              }

              // Programas Públicos
              if(element.amount_of_scopes == 0){
                this.planGold +=
                 `<p class='not'>${self.$ml.get('scopePerProgram')}</p>`;
              }else{
                this.planGold +=
                 `<p>${element.amount_of_scopes } ${element.amount_of_scopes > 1 ? self.$ml.get('scopesPerProgram') : self.$ml.get('scopePerProgram')}</p>`;
              }
 
              this.planGold += `
                <p class="${element.export_reports_to_csv ? '' : 'not'}">${self.$ml.get('exportInCsv')}</p>
                <p class="${element.integration_types.length ? '' : 'not'}">${self.$ml.get('integrations')}<br>(Slack, Teams)</p> 
              ` 
            }
                // <p class="${element.can_request_special_agreement_therms ? '' : 'not'}">Solicitação de assinatura de NDA</p>
  
          });
 
          this.loading = false;
  
        },
        () => {
          this.loading = false;
        }
      );
       
    },
  },
};
</script>

<style scoped>
.b-red{
  background-color: red !important;
} 

.baseBlock {  
	-moz-transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
	-o-transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
	transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  cursor: pointer;
}

.baseBlock:hover {
	-webkit-transform: translate(0, -17px);
	-moz-transform: translate(0, -17px);
	-ms-transform: translate(0, -17px);
	-o-transform: translate(0, -17px);
	transform: translate(0, -17px);
	box-shadow: 0 40px 40px rgba(0, 0, 0, 0.2);
}

.selected {
	-webkit-transform: translate(0, -17px);
	-moz-transform: translate(0, -17px);
	-ms-transform: translate(0, -17px);
	-o-transform: translate(0, -17px);
	transform: translate(0, -17px);
	box-shadow: 0 40px 40px rgba(0, 0, 0, 0.2);
}

 
</style>